var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrustpilotStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 18,
    viewBox: "0 0 100 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.437 0.330566H0V17.7676H17.437V0.330566Z",
    fill: "#00734A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2468 7.4026H10.3468L8.82779 2.7356L7.30479 7.4026H2.40479L6.37579 10.2856L4.85679 14.9476L8.82779 12.0656L12.7948 14.9486L11.2798 10.2856L15.2468 7.4026Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M11.6206 11.3416L11.2796 10.2856L8.82764 12.0656L11.6206 11.3416Z",
    fill: "#003d26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8808 0.330566H20.4438V17.7676H37.8808V0.330566Z",
    fill: "#00734A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6906 7.4026H30.7906L29.2716 2.7356L27.7486 7.4026H22.8486L26.8196 10.2856L25.3006 14.9476L29.2716 12.0656L33.2386 14.9486L31.7236 10.2856L35.6906 7.4026Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M32.0645 11.3416L31.7235 10.2856L29.2715 12.0656L32.0645 11.3416Z",
    fill: "#003d26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3242 0.330566H40.8872V17.7676H58.3242V0.330566Z",
    fill: "#00734A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.134 7.4026H51.234L49.715 2.7356L48.192 7.4026H43.292L47.263 10.2856L45.744 14.9476L49.715 12.0656L53.682 14.9486L52.167 10.2856L56.134 7.4026Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M52.5078 11.3416L52.1668 10.2856L49.7148 12.0656L52.5078 11.3416Z",
    fill: "#003d26"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7681 0.330566H61.3311V17.7676H78.7681V0.330566Z",
    fill: "#00734A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5778 7.4026H71.6778L70.1588 2.7356L68.6358 7.4026H63.7358L67.7068 10.2856L66.1878 14.9476L70.1588 12.0656L74.1258 14.9486L72.6108 10.2856L76.5778 7.4026Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M72.9517 11.3416L72.6107 10.2856L70.1587 12.0656L72.9517 11.3416Z",
    fill: "#003d26"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2119 0.330566H81.7749V17.7676H99.2119V0.330566Z",
    fill: "#00734A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0217 7.4026H92.1217L90.6027 2.7356L89.0797 7.4026H84.1797L88.1507 10.2856L86.6317 14.9476L90.6027 12.0656L94.5697 14.9486L93.0547 10.2856L97.0217 7.4026Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M93.3955 11.3416L93.0545 10.2856L90.6025 12.0656L93.3955 11.3416Z",
    fill: "#003d26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilotStars);
export default __webpack_public_path__ + "static/media/trustpilotStars.bb3673b3d209675aba62f1d8b88139b6.svg";
export { ForwardRef as ReactComponent };